// extracted by mini-css-extract-plugin
module.exports = {"button":"SearchInput-module__button___kkbWe"};